/**
 * A tab opened before a deploy still points at chunk files the new build no longer serves.
 * The first failure reloads the current document once (fresh HTML, fresh chunk URLs).
 * If a safe reload guard cannot be stored, or recovery was just attempted, the caller shows its retry UI.
 */
const KEY = 'zavira_chunk_recovery_at';
const WINDOW_MS = 30_000;

export const recoverFromChunkError = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    const last = Number(window.sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last < WINDOW_MS) return false;
    window.sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    // Without a persisted guard a fresh document would reload indefinitely.
    // Let the caller display its normal error/retry UI instead.
    return false;
  }
  let reloaded = false;
  const reload = () => {
    if (reloaded) return;
    reloaded = true;
    clearTimeout(deadline);
    window.location.reload();
  };
  // CacheStorage is best-effort: restricted access or an unsettled operation
  // must not prevent recovery. The timer also bounds cache deletion.
  const deadline = setTimeout(reload, 2_000);
  try {
    const cacheStorage = window.caches;
    if (cacheStorage) {
      void cacheStorage.keys()
        .then((keys) => Promise.allSettled(keys.map((key) => cacheStorage.delete(key))))
        .then(reload, reload);
    } else {
      reload();
    }
  } catch {
    reload();
  }
  return true;
};
